import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CounterCard from './CounterCard';
export default function IndexStats() {
    return (
        <Box
            width="100%"
            sx={{
                background: '#242331',
                display: 'grid',
                placeItems: 'center',
                py: 8,
            }}
        >
            <Grid container maxWidth="lg" spacing={2} justifyContent="center" sx={{ px: 2 }}>
                <Grid item xs={12} textAlign="center" mb={2}>
                    <Typography variant="h3" color="grey.100" fontWeight="bold">
                        The Threat Landscape
                    </Typography>
                    <Typography variant="h6" color="grey.500" mt={1} sx={{ maxWidth: '600px', mx: 'auto' }}>
                        Cyberattacks against small businesses are rising every year.
                        The question is no longer if, but <Typography display="inline" variant="h6" color="grey.200" fontWeight="bold"> when</Typography>.
                    </Typography>
                </Grid>
            </Grid>
             <Grid container maxWidth="lg" spacing={2} justifyContent="center" sx={{ px: 2 }}>
                {[
                    {
                        count: 90,
                        suffix: '%',
                        title: 'Start with Phishing',
                        description: 'Of cyberattacks begin with a phishing email to steal credentials',
                    },
                    {
                        count: 4.88,
                        decimals: 2,
                        prefix: '$',
                        suffix: 'M',
                        title: 'The Average Breach Cost',
                        description: 'IBM Cost of a Data Breach Report 2024',
                    },
                    {
                        count: 68,
                        suffix: '%',
                        title: 'Involve Human Error',
                        description: 'Opening phishing emails is the leading cause of major breaches',
                    },
                ].map(({ count, suffix, prefix, decimals, title, description }) => (
                    <Grid item size={{ xs: 12, md: 4 }} key={title}>
                        <Card
                            sx={{
                                minHeight: 260,
                                background: 'linear-gradient(160deg, #d90000, #aa0000)',
                                border: '1px solid rgba(255,255,255,0.08)',
                                borderRadius: 2,
                            }}
                        >
                            <CardContent>
                                <CounterCard
                                    color="grey.200"
                                    count={count}
                                    suffix={suffix}
                                    prefix={prefix}
                                    decimals={decimals}
                                    title={title}
                                    description={description}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
